"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.truncate = exports.toRepr = exports.maybeParen = exports.isFunction = exports.initializeTranslations = exports.gettext = exports.escapeHtml = void 0;
var _striptags = _interopRequireDefault(require("striptags"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var translations = {};
var initializeTranslations = function initializeTranslations(translationJson) {
  return _objectSpread(_objectSpread({}, translations), translationJson);
};
exports.initializeTranslations = initializeTranslations;
var gettext = function gettext(key) {
  if (translations[key]) {
    return translations[key].default;
  }
  return key;
};
exports.gettext = gettext;
var isFunction = function isFunction(obj) {
  if (typeof /./ !== 'function' && typeof Int8Array !== 'object') {
    return typeof obj === 'function' || false;
  }
  return Object.toString.call(obj) === '[object Function]';
};
exports.isFunction = isFunction;
var truncate = function truncate(str, maxLength) {
  var stripedString = (0, _striptags.default)(str);
  if (!maxLength || stripedString.length <= maxLength) {
    return str;
  }
  return "".concat(str.substr(0, stripedString.lastIndexOf(' ', 20)), "...");
};
exports.truncate = truncate;
var escapeHtml = function escapeHtml(text) {
  return text.replace(/&/g, '&amp;').replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/"/g, '&quot;').replace(/\$/g, '&#36;');
};
exports.escapeHtml = escapeHtml;
var maybeParen = function maybeParen(parent, child) {
  var _parent$op;
  var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var text = arguments.length > 3 ? arguments[3] : undefined;
  var result = text !== null && text !== void 0 ? text : child.toString();
  if (!child.op) {
    return result;
  }
  if (parent.op && child.op.precedence > parent.op.precedence) {
    return result;
  }
  if (child.op.precedence === ((_parent$op = parent.op) === null || _parent$op === void 0 ? void 0 : _parent$op.precedence) && !right) {
    return result;
  }
  return "(".concat(result, ")");
};
exports.maybeParen = maybeParen;
var toRepr = function toRepr(obj) {
  if (!obj) {
    return 'null';
  }
  if (obj instanceof Array) {
    return "[".concat(obj.map(toRepr).join(', '), "]");
  }
  if (typeof obj === 'object' && 'toRepr' in obj) {
    return obj.toRepr();
  }
  return obj.toString();
};
exports.toRepr = toRepr;